export const buildProductUsageOrEmpty = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (!data) {
        return {
            productSku: null,
            daysLeftInTrial: null,
            numberOfExports: null,
            numberOfImports: null,
            stlImportsExports: null,
            hasCompletedAnyTraining: null,
            hasStartedAnyTraining: null,
            uUsageTimeL30D: 0,
            uUsageTimeTotal: 0,
            uUsageTimeL7D: 0,
            uOSProductUsageId: null,
        };
    }
    return {
        productSku: (_a = data.productSku) !== null && _a !== void 0 ? _a : null,
        daysLeftInTrial: (_b = data.daysLeftInTrial) !== null && _b !== void 0 ? _b : null,
        numberOfExports: (_c = data.numberOfExports) !== null && _c !== void 0 ? _c : null,
        numberOfImports: (_d = data.numberOfImports) !== null && _d !== void 0 ? _d : null,
        stlImportsExports: (_e = data.stlImportsExports) !== null && _e !== void 0 ? _e : null,
        hasCompletedAnyTraining: (_f = data.hasCompletedAnyTraining) !== null && _f !== void 0 ? _f : null,
        hasStartedAnyTraining: (_g = data.hasStartedAnyTraining) !== null && _g !== void 0 ? _g : null,
        uUsageTimeL30D: (_h = data.uUsageTimeL30D) !== null && _h !== void 0 ? _h : 0,
        uUsageTimeTotal: (_j = data.uUsageTimeTotal) !== null && _j !== void 0 ? _j : 0,
        uUsageTimeL7D: (_k = data.uUsageTimeL7D) !== null && _k !== void 0 ? _k : 0,
        uOSProductUsageId: (_l = data.uOSProductUsageId) !== null && _l !== void 0 ? _l : null,
    };
};
